const minHeight = typeof window !== 'undefined' && window.innerHeight
const minWidth = typeof window !== 'undefined' && window.innerWidth

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    marginLeft: theme.spacing.unit * 2
  },
  modal: {
    minWidth: minWidth / 2,
    maxWidth: minWidth / 1.5
  },
  flex: {
    flex: 1
  },
  logoSelect: {
    marginTop: theme.spacing.unit * 2,
    '&:hover': {
      backgroundColor: '#fd5622'
    }
  },
  logoPreviewHolder: {
    background: theme.palette.grey[100],
    padding: theme.spacing.unit * 4,
    textAlign: 'center',
    minHeight: minHeight / 5,
    flexGrow: 1,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoPreview: {
    height: 'auto',
    maxWidth: 400,
    borderRadius: 4,
    overflow: 'auto',
    maxHeight: 274
  },
  logoHelp: {
      color: 'red',
      fontSize: '0.8em'
  }
})

export default styles
